import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Dispatch',
	url: '/dispatch',
	icon: 'dashboard',
}];

export default class DispatchLogs extends Framework.Components.View {

	render() {

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Logs",
				url: `/dispatch/logs`,
				icon: 'archive',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<Collections.LogsCalendar
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={this.props.roles.includes(UserRoles.Admin)}
				/>
			</div>
		);
	}
}

